import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Admin() {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    (async () => {
      const [s, u] = await Promise.all([api.get("/admin/stats"), api.get("/admin/users")]);
      setStats(s.data);
      setUsers(u.data);
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="admin-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Admin</div>
      <h1 className="font-display text-4xl font-bold tracking-tight text-slate-950 mt-1">Platform overview</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">All users, all courses, all credentials in one place.</p>

      {stats && (
        <div className="mt-8 grid grid-cols-2 md:grid-cols-5 gap-4">
          {[
            ["Total Users", stats.users, "users"],
            ["Trainees", stats.trainees, "trainees"],
            ["Courses", stats.courses, "courses"],
            ["Attempts", stats.quiz_attempts, "attempts"],
            ["Certificates", stats.certificates_issued, "certs"],
          ].map(([l, v, k]) => (
            <div key={k} data-testid={`admin-kpi-${k}`} className="border border-slate-200 rounded-sm p-5 bg-white">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">{l}</div>
              <div className="font-display font-black text-3xl tracking-tighter mt-3 text-slate-950">{v}</div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-10">
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Users</h2>
        <div className="mt-3 border border-slate-200 rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-[0.2em] font-bold text-slate-500">
              <tr>
                <th className="text-left p-4">Name</th>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4">Role</th>
                <th className="text-left p-4">Provider</th>
                <th className="text-right p-4">Joined</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.user_id} className="border-t border-slate-200">
                  <td className="p-4 font-semibold text-slate-900">{u.name}</td>
                  <td className="p-4 text-slate-700">{u.email}</td>
                  <td className="p-4">
                    <span className={`inline-block px-2 py-0.5 text-xs font-bold uppercase tracking-[0.15em] rounded-sm ${
                      u.role === "admin" ? "bg-orange-600 text-white"
                      : u.role === "instructor" ? "bg-slate-900 text-white"
                      : "bg-slate-100 text-slate-700"
                    }`}>{u.role}</span>
                  </td>
                  <td className="p-4 text-slate-700 font-mono text-xs">{u.auth_provider || "password"}</td>
                  <td className="p-4 text-right text-slate-700">{u.created_at?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
